module.exports = __webpack_public_path__ + "static/media/280988.0f8713ce.png";